<template>
  <appointment-form type="New" v-bind="props" />
</template>

<script setup lang="ts">
import AppointmentForm from "../components/AppointmentFrom/Index.vue";
import { Timeslot } from "../components/AppointmentFrom/types";

export interface Props {
  timeslots: Record<
    number,
    Record<number, Timeslot & { startDt: string; endDt: string }>
  >;
  buildingOptions: Array<[string, number]>;
  locked?: boolean;
  initialBuilding: number;
  initialDate: string;
  introTexts: Record<number, string | null>;
  disabledDates: Record<number, { min: string; max: string; dates: string[] }>;

  initialTimeslot?: null | number;
  prevAppointmentId?: null | number;
}

const props = withDefaults(defineProps<Props>(), {
  locked: false,
  initialTimeslot: null,
});
</script>
